export const SeparatorIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 3 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity={0.2}
        d="M1.5 6.625a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zM2.625 1.75a1.125 1.125 0 10-2.25 0 1.125 1.125 0 002.25 0zm0 7.5a1.125 1.125 0 10-2.25 0 1.125 1.125 0 002.25 0z"
        fill="currentColor"
      />
      <path
        d="M3 5.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-2.25 0a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3 1.75a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-2.25 0a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3 9.25a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-2.25 0a.75.75 0 111.5 0 .75.75 0 01-1.5 0z"
        fill="currentColor"
      />
    </svg>
  );
};
